import { MenuItem, Stack, TextField } from '@mui/material';
import { WizardValues } from './wizardTypes';

interface Step8Props {
  values: WizardValues;
  setField: <K extends keyof WizardValues>(field: K, value: WizardValues[K]) => void;
}

export const Step8FinancialInformation = ({ values, setField }: Step8Props) => (
  <Stack spacing={2}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        label="Monthly income"
        type="number"
        fullWidth
        value={values.monthlyIncome}
        onChange={(e) => setField('monthlyIncome', e.target.value ? Number(e.target.value) : '')}
      />
      <TextField
        label="Annual income"
        type="number"
        fullWidth
        value={values.annualIncome}
        onChange={(e) => setField('annualIncome', e.target.value ? Number(e.target.value) : '')}
      />
    </Stack>

    <TextField
      select
      label="Funding method"
      fullWidth
      value={values.fundingMethod}
      onChange={(e) => setField('fundingMethod', e.target.value as WizardValues['fundingMethod'])}
    >
      <MenuItem value="">
        <em>Not specified</em>
      </MenuItem>
      <MenuItem value="SELF">Self</MenuItem>
      <MenuItem value="PARENTS">Parents</MenuItem>
      <MenuItem value="LOAN">Loan</MenuItem>
      <MenuItem value="SPONSOR">Sponsor</MenuItem>
      <MenuItem value="SCHOLARSHIP">Scholarship</MenuItem>
      <MenuItem value="EMPLOYER">Employer</MenuItem>
      <MenuItem value="OTHER">Other</MenuItem>
    </TextField>

    {(values.fundingMethod === 'SPONSOR' || values.fundingMethod === 'OTHER') && (
      <TextField
        label="Sponsor details"
        fullWidth
        multiline
        minRows={2}
        value={values.sponsorDetails}
        onChange={(e) => setField('sponsorDetails', e.target.value)}
      />
    )}
  </Stack>
);
